module.exports = __webpack_public_path__ + "static/media/arrow_gray.d2d1436c.svg";